<template>
  <div v-on:click="go()" class="neu-card-general-ctn">
    <div class="neu-card-general btn-min-height">
      <div>
        <base-icon class="vertical icon-width-logo" v-if="src === '/static-appopensalud/img/logos/opensalud360_healthierlives_color.svg'" :src="src" blue fullWidth shadow :color="iconColor"></base-icon>
        <base-icon class="vertical icon-width-prof" v-if="src!= '/static-appopensalud/img/logos/healthierlives_color.svg' && src != '/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png' && src != '/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png'" :src="src" blue fullWidth shadow :color="iconColor"></base-icon>
      <!-- <img class="vertical icon-width-prof img-icon" v-if="src == '/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png'" src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png"/> -->
      <img class="vertical icon-width-prof img-icon" v-if="src == '/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png'" src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png"/>
        <!-- <img style="background-image: url('/static-appopensalud/img/bgs/opt/doctor-male.svg');background-size:cover" class="vertical icon-width-prof" :src="src"/> -->
      </div>
    <div class="subtitle-general mx-auto">
      <p v-if="link === null" v-html="paddedTitle"></p>
        <p v-if="link === '360'" v-on:click="go360()" v-html="paddedTitle"></p>
      <router-link v-if="link !== null && link !== '360'" :to="link" tag="a">
        <p v-html="paddedTitle"></p>
      </router-link>
      <span v-if="subtitle != undefined" v-html="paddedSubtitle">
      </span>
    </div>
    </div>
  </div>
</template>

<script>
import es from '@/lang/es/public/views/opensalud-pacientes.json'
import en from '@/lang/en/public/views/opensalud-pacientes.json'
import { BLUE_COLOUR } from '@/constants/colours'

export default {
  name: 'neu-card-general',
  i18n: {
    reviews: {
      es: es,
      en: en,
      mx: es
    }
  },
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: false,
      default: null
    },
    subtitle: {
      type: String,
      required: false
    },
    subtitleLines: Number,
    titleLines: Number,
    iconColor: {
      type: String,
      required: false,
      default: BLUE_COLOUR
    }
  },
  computed: {
    go () {
      this.$router.push(this.link)
    },
/*     go360 () {
      const url = window.location.hostname.split('.')
      const envSubdomain = url[0].includes('desarrollo-360') ? 'desarrollo-' : url[0].includes('pruebas-360') ? 'pruebas-' : url[0].includes('360') ? '' : url[0].includes('localhost') ? '' : ''
      location.href = `https://${envSubdomain}360.opensalud.es`
    },
    goPat () {
      const url = window.location.hostname.split('.')
      const envSubdomain = url[0].includes('desarrollo') ? 'desarrollo.opensalud.es' : url[0].includes('pruebas') ? 'pruebas.opensalud.es' : url[0].includes('localhost') ? 'localhost:8080' : ''
      location.href = `https://${envSubdomain}/pacientes`
    },
    goProf () {
      const url = window.location.hostname.split('.')
      const envSubdomain = url[0].includes('desarrollo') ? 'desarrollo.opensalud.es' : url[0].includes('pruebas') ? 'pruebas.opensalud.es' : url[0].includes('localhost') ? 'localhost:8080' : ''
      location.href = `https://${envSubdomain}/profesionales`
    }, */
    paddedTitle () {
      return this.titleLines ? `${this.title}${'<br>'.repeat(this.titleLines)}` : this.title
    },
    paddedSubtitle () {
      return this.subtitleLines ? `${'<br>'.repeat(this.titleLines)}${this.subtitle}${'&ensp;'}` : `${this.subtitle}${'&ensp;'}${'&ensp;'}`
    }
  }
}
</script>

<style lang="scss" scoped>
.img-icon {
        margin: auto;
        &.vertical {
          height: 150px;
          @include mobile {
            height: 150px;
          }
        }
        &:not(.vertical) {
          width: 100px;
          @include mobile {
            width: 150px;
          }
        }

        object-fit: cover;
      }
.neu-card-general-ctn {
  // position: relative;
  // display: flex !important;
  align-items: center;
    transition-duration: 1s;
    @include mobile {
      padding-top: 3rem !important;
    }
    
  .neu-card-general {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // position: relative;
    transition-duration: 1s;
    
    //   .icon-width-prof{
    // @include mobile{
    // -webkit-margin-after: 11rem !important;

    // }
    // @media screen and (min-width: 1024px) and (max-width: 1440px) {
    //   margin-top: 3rem;

    // }
    // }
    // position: relative;
    // display: inline-flex !important;
    .icon-width-prof{
      width:7rem;
      @include mobile{
        width: 5rem;
      }
      display: inline-block;
      margin-block-end: 0rem;
      -webkit-margin-after: 1rem;
    }
    .icon-width-logo{
      width: 15rem;
      display: inline-block;
      margin-block-end: 5rem;
      -webkit-margin-after: 4rem;
      -webkit-margin-before: 1rem;
    }
    .div {
      padding: 0.5rem;
    }
    img{
      // position: absolute;
      width: 11rem;
      height: 11rem;
      transition-property: none;
    }
    /* &:hover {
      @include desktop {
        padding: 4rem 6rem;
      }
      @include desktop-sm {
        padding: 0rem 4rem;
      }

      transition-duration: 1s;
    } */
      .subtitle-general  {
        p {
          color: $blue;
        }
        // @include desktop{
        //   span {
        //     position: absolute;
        //     bottom: 0;
        //   }
        // }
        // @include desktop-sm{
        //   span {
        //     position: absolute;
        //     bottom: 0;
        //   }
        // }
        // @include tablets{
        //   span {
        //     position: absolute;
        //     bottom: 0;
        //   }
        // }
      
    text-align: center;
          width: 90%;
    // @include desktop {
    //   margin-top: 5rem;
    // }
    // @include mobile {
    //   margin-top: 4rem !important;
    // }

    p {
      @include mobile {
        width: 100%;
        // margin-top: 13rem !important;
        // margin-bottom: 4.5rem !important;
      }
       
      font-weight: bold;
      text-align: center;
      @include tablets {
        font-size: 1.5rem;
      }
      white-space: normal;
      // padding-bottom: 3rem;
    }
  }
    box-shadow: $custom-shadow;
    border: $border;
    border-radius: $border-radius;

    // Neu Icon vertically centered
    // span {
    //   display: contents;

    //   @include mobile{
    //     display: block;

    //   }
    // }
  }


}

</style>


// WEBPACK FOOTER //
// src/components/base/ui/NeuCardGeneral.vue